import { render, staticRenderFns } from "./allUserCupList.vue?vue&type=template&id=06315415&scoped=true"
import script from "./allUserCupList.vue?vue&type=script&lang=js"
export * from "./allUserCupList.vue?vue&type=script&lang=js"
import style0 from "./allUserCupList.vue?vue&type=style&index=0&id=06315415&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06315415",
  null
  
)

export default component.exports